
























import Vue from "vue";
import { scopeToggleState } from "@tt-app/utils";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";
import { audioContext } from "@tt-app/utils/audio/audioContext";

import IconCheckbox from "@joyz/app-core/assets/icons/default/Checkbox.svg";
import IconCheckboxActive from "@joyz/app-core/assets/icons/active/Checkbox.svg";
import IconSpeaker from "@joyz/app-core/assets/icons/default/Speaker.svg";

interface Data {
  icons: { [key: string]: string };
}

interface Methods {
  onScopeItemClick: () => void;
  playAudio: (event: MouseEvent) => void;
}

interface Computed {
  checked: boolean;
  checkboxIcon: string;
  showEnglish: boolean;
  showTranslation: boolean;
}

interface Props {
  audioDecoderPlayer: AudioDecoderPlayer;
  audioUrl: string;
  isWord: boolean;
  learnedStatus: number;
  problemUuid: string;
  selectedUuids: any[];
  textEn: string;
  textJa: string;
  toggleState: number;
  wordUuid: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ExerciseScopeItem",

  props: {
    audioDecoderPlayer: { type: AudioDecoderPlayer, default: undefined },
    audioUrl: { type: String, default: "" },
    isWord: { type: Boolean, default: false },
    learnedStatus: Number,
    problemUuid: { type: String, default: "" },
    selectedUuids: { type: Array, default: () => [] },
    textEn: { type: String, default: "" },
    textJa: { type: String, default: "" },
    toggleState: { type: Number, default: 0 },
    wordUuid: { type: String, default: "" }
  },

  data() {
    return {
      icons: {
        checkbox: IconCheckbox,
        checkboxActive: IconCheckboxActive,
        speaker: IconSpeaker
      }
    };
  },

  methods: {
    onScopeItemClick() {
      this.$emit("click", { problemUuid: this.problemUuid });
    },

    async playAudio(event) {
      event.stopPropagation();

      if (this.audioDecoderPlayer.status === "playing") {
        this.audioDecoderPlayer.stop();
      }

      await audioContext.resume();
      await this.audioDecoderPlayer.play(this.audioUrl);
    }
  },

  computed: {
    checked() {
      return this.selectedUuids.includes(this.problemUuid);
    },

    checkboxIcon() {
      return this.checked ? this.icons.checkboxActive : this.icons.checkbox;
    },

    showEnglish() {
      return [scopeToggleState.none, scopeToggleState.translation].includes(this.toggleState);
    },

    showTranslation() {
      return [scopeToggleState.none, scopeToggleState.english].includes(this.toggleState);
    }
  }
});
